// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_mob {
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
  overflow-y: auto;
}

.top {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.bottom {
  flex: 1 1;
  position: relative;
  z-index: 0;
}

.image1 {
  margin-bottom: 225px;
  width: 65%;
  height: 25%;
}

.image2 {
  position: absolute;
  bottom: -20px;
  z-index: 9999;
  width: 100%;
  height: 80%;
  filter: drop-shadow(5px 12px 5px #0c3468);
  ;

}


.split {
  display: flex;
  flex-direction: row;
}

.image-class {
  width: 110px;
  height: 110px;
  object-fit: 'contain'
}

.logoImgpick {
  display: flex;
  align-items: center;
  justify-items: center;
  position: absolute;
  top: 25%;
  left: 15%;
  width: 75%;
  height: 40%;

}

.dogImgStyle {
  position: absolute;
  width: 85%;
  height: 115%;
  top: 2%;
  /* right: 5%; */
  bottom: 0px;
  left: 7%;
  /* filter: drop-shadow(0px 13px 5px #0c3468); */
  ;
}

.div-50 {
  background-color: #0c3468;
  height: 100%;
  background-image: linear-gradient(180deg, #34549f 2%, #0c3468 40%, #061d3a 100%);
}

.textprod {
  padding-top: 25px;
}

.buttonDiv {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
}

.button {
  background-color: #ffffff;
  border: none;
  color: white;
  padding: 5px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  margin: 30px;
  cursor: pointer;
}

.button1 {
  background-color: #f0ac03;
  border-radius: 50%;
}

.button2 {
  border-radius: 50%;
  background-color: #000000;
}

.button3 {
  border-radius: 50%;
  background-color: #FFFFFF;
}

.footer-wrapper {
  display: flex;
  position: fixed;
  flex-wrap: wrap;
  /* bottom: 0; */
  z-index: 9999;
  width: 100%;
  height: 15%;
  align-items: center;
  justify-content: center;
  padding-bottom: 40px;
}

select#dropdown {
  border: 1px solid;
  outline: 0px;
}

.dropdown {
  display: flex;
  position: relative;
  color: #FFFFFF;
  align-self: center;
  justify-self: center;
}


/* ---------Mobile--------- */

@media (min-width: 280px) and (max-width: 319.98px) {
  .image-class {
    max-width: 40px;
    max-height: 40px;
  }
   
  .textprodText {
    color: #FFFFFF;
    font-size: 15px
  }

  .button {
    margin-top: 35px;
    padding: 20px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .image1{
    margin-top: 15%;
    width: 70%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -15%;
    z-index: 9999;
    width: 105%;
    height: 70%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 35px;
  }

  /* .footer-wrapper {
    height: 12%;
  } */

}

@media (min-width: 320px) and (max-width:374.98px) {
  .image-class {
    max-width: 80px;
    max-height: 80px;
  }
  
  .textprodText {
    color: #FFFFFF;
    font-size: 15px
  }

  .button {
    margin-top: 35px;
    padding: 10px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .image1{
    margin-top: 20px;
    width: 70%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -16%;
    z-index: 9999;
    width: 105%;
    height: 75%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 30px;
  }

  /* .footer-wrapper {
    height: 20%;
  } */
}

@media (min-width:375px) and (max-width:389.98px) {

  .image-class {
    max-width: 85px;
    max-height: 85px;
  }
 
  .textprodText {
    color: #FFFFFF;
    font-size: 17px
  }

  .button {
    margin-top: 35px;
    padding: 12px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .image1 {
    margin-top: 15px;
    width: 70%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -18%;
    z-index: 9999;
    width: 105%;
    height: 82%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 30px;
  }

  /* .footer-wrapper {
    height: 25%;
  } */

}

@media (min-width:390px) and (max-width:539.98px) {

  .image-class {
    max-width: 85px;
    max-height: 85px;
  }
  
  .textprodText {
    color: #FFFFFF;
    font-size: 20px
  }

  .button {
    margin-top: 35px;
    padding: 12px;
    margin-left: 8px;
    margin-right: 8px;
  }

  .image1 {
    margin-top: -20px;
    width: 70%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -18%;
    z-index: 9999;
    width: 105%;
    height: 82%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 30px;
  }

  /* .footer-wrapper {
    height: 25%;
  } */

}

@media (min-width:540px) and (max-width:575.98px) {

  .image-class {
    max-width: 85px;
    max-height: 85px;
  }
  
  .textprodText {
    color: #FFFFFF;
    font-size: 20px
  }

  .button {
    margin-top: 35px;
    padding: 12px;
    margin-left: 18px;
    margin-right: 18px;
  }

  .image1 {
    margin-top: -5%;
    width: 70%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -19%;
    z-index: 9999;
    width: 90%;
    height: 85%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 30px;
  }
  
}

@media (min-width:576px) and (max-width:767.98px) {

  .image-class {
    max-width: 95px;
    max-height: 95px;
  }
  
  .textprodText {
    color: #FFFFFF;
    font-size: 20px
  }

  .button {
    margin-top: 35px;
    padding: 10px;
    margin-left: 15px;
    margin-right: 15px;
  }

  .image1{
    margin-top: 20px;
    width: 60%;
    height: 23%;
  }

  .image2 {
    position: absolute;
    bottom: -19%;
    z-index: 9999;
    width: 80%;
    height: 85%;
    filter: drop-shadow(0px 13px 5px #0c3468);

  }

  .textprod {
    padding-top: 30px;
  }

  .footer-wrapper {
    height: 25%;
  }

}


 /* Desktop */
@media (min-width:768px) and (max-width:991.98px) {

  .image-class {
    max-width: 100px;
    max-height: 100px;
  }

  .button {
    /* margin-top: 50px;
    padding: 20px; */
    margin-left: 20px;
    margin-right: 20px;
  }


  .textprod {
    padding-top: 30px;
  }

  /* .footer-wrapper {
    height: 25%;
  } */

  .dogImgStyle {
    position: absolute;
    width: 85%;
    height: 95%;
    top: 18%;
    /* right: 5%; */
    bottom: 0px;
    left: 7%;
    /* filter: drop-shadow(0px 13px 5px #0c3468); */
    ;
  }

}

@media (min-width:992px) and (max-width:1199.98px) {
 .image-class {
    max-width: 100px;
    max-height: 100px;
  }

 .textprod {
    padding-top: 15px;
  }

  /*  .footer-wrapper {
    height: 25%;
  } */

  .dogImgStyle {
    position: absolute;
    width: 85%;
    height: 110%;
    top: 7%;
    /* right: 5%; */
    bottom: 0px;
    left: 7%;
    /* filter: drop-shadow(0px 13px 5px #0c3468); */
    ;
  }
}

@media (min-width:1200px) and (max-width:1279.98px) {
  .image-class {
    max-width: 105px;
    max-height: 105px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Dogpage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,WAAW;EACX,WAAW;EACX,yCAAyC;;;AAG3C;;;AAGA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,OAAO;EACP,eAAe;EACf,WAAW;EACX,QAAQ;EACR,+CAA+C;;AAEjD;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,eAAe;EACf,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;;AAGA,6BAA6B;;AAE7B;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;;AAEL;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;AACL;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;;AAEL;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;;AAEL;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd;EACF;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,UAAU;IACV,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,UAAU;IACV,WAAW;IACX,yCAAyC;;EAE3C;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;AAEF;;;CAGC,YAAY;AACb;;EAEE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE;oBACgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;IACE,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,QAAQ;IACR,eAAe;IACf,WAAW;IACX,QAAQ;IACR,+CAA+C;;EAEjD;;AAEF;;AAEA;CACC;IACG,gBAAgB;IAChB,iBAAiB;EACnB;;CAED;IACG,iBAAiB;EACnB;;EAEA;;KAEG;;EAEH;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,OAAO;IACP,eAAe;IACf,WAAW;IACX,QAAQ;IACR,+CAA+C;;EAEjD;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF","sourcesContent":[".container_mob {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  width: 100%;\n  height: 100vh;\n  background-color: #FFFFFF;\n  overflow-y: auto;\n}\n\n.top {\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n}\n\n.bottom {\n  flex: 1;\n  position: relative;\n  z-index: 0;\n}\n\n.image1 {\n  margin-bottom: 225px;\n  width: 65%;\n  height: 25%;\n}\n\n.image2 {\n  position: absolute;\n  bottom: -20px;\n  z-index: 9999;\n  width: 100%;\n  height: 80%;\n  filter: drop-shadow(5px 12px 5px #0c3468);\n  ;\n\n}\n\n\n.split {\n  display: flex;\n  flex-direction: row;\n}\n\n.image-class {\n  width: 110px;\n  height: 110px;\n  object-fit: 'contain'\n}\n\n.logoImgpick {\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  position: absolute;\n  top: 25%;\n  left: 15%;\n  width: 75%;\n  height: 40%;\n\n}\n\n.dogImgStyle {\n  position: absolute;\n  width: 85%;\n  height: 115%;\n  top: 2%;\n  /* right: 5%; */\n  bottom: 0px;\n  left: 7%;\n  /* filter: drop-shadow(0px 13px 5px #0c3468); */\n  ;\n}\n\n.div-50 {\n  background-color: #0c3468;\n  height: 100%;\n  background-image: linear-gradient(180deg, #34549f 2%, #0c3468 40%, #061d3a 100%);\n}\n\n.textprod {\n  padding-top: 25px;\n}\n\n.buttonDiv {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n\n.button {\n  background-color: #ffffff;\n  border: none;\n  color: white;\n  padding: 5px;\n  text-align: center;\n  text-decoration: none;\n  display: inline-block;\n  margin: 30px;\n  cursor: pointer;\n}\n\n.button1 {\n  background-color: #f0ac03;\n  border-radius: 50%;\n}\n\n.button2 {\n  border-radius: 50%;\n  background-color: #000000;\n}\n\n.button3 {\n  border-radius: 50%;\n  background-color: #FFFFFF;\n}\n\n.footer-wrapper {\n  display: flex;\n  position: fixed;\n  flex-wrap: wrap;\n  /* bottom: 0; */\n  z-index: 9999;\n  width: 100%;\n  height: 15%;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 40px;\n}\n\nselect#dropdown {\n  border: 1px solid;\n  outline: 0px;\n}\n\n.dropdown {\n  display: flex;\n  position: relative;\n  color: #FFFFFF;\n  align-self: center;\n  justify-self: center;\n}\n\n\n/* ---------Mobile--------- */\n\n@media (min-width: 280px) and (max-width: 319.98px) {\n  .image-class {\n    max-width: 40px;\n    max-height: 40px;\n  }\n   \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 15px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 20px;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n\n  .image1{\n    margin-top: 15%;\n    width: 70%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -15%;\n    z-index: 9999;\n    width: 105%;\n    height: 70%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 35px;\n  }\n\n  /* .footer-wrapper {\n    height: 12%;\n  } */\n\n}\n\n@media (min-width: 320px) and (max-width:374.98px) {\n  .image-class {\n    max-width: 80px;\n    max-height: 80px;\n  }\n  \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 15px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 10px;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n\n  .image1{\n    margin-top: 20px;\n    width: 70%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -16%;\n    z-index: 9999;\n    width: 105%;\n    height: 75%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 30px;\n  }\n\n  /* .footer-wrapper {\n    height: 20%;\n  } */\n}\n\n@media (min-width:375px) and (max-width:389.98px) {\n\n  .image-class {\n    max-width: 85px;\n    max-height: 85px;\n  }\n \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 17px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 12px;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n\n  .image1 {\n    margin-top: 15px;\n    width: 70%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -18%;\n    z-index: 9999;\n    width: 105%;\n    height: 82%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 30px;\n  }\n\n  /* .footer-wrapper {\n    height: 25%;\n  } */\n\n}\n\n@media (min-width:390px) and (max-width:539.98px) {\n\n  .image-class {\n    max-width: 85px;\n    max-height: 85px;\n  }\n  \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 20px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 12px;\n    margin-left: 8px;\n    margin-right: 8px;\n  }\n\n  .image1 {\n    margin-top: -20px;\n    width: 70%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -18%;\n    z-index: 9999;\n    width: 105%;\n    height: 82%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 30px;\n  }\n\n  /* .footer-wrapper {\n    height: 25%;\n  } */\n\n}\n\n@media (min-width:540px) and (max-width:575.98px) {\n\n  .image-class {\n    max-width: 85px;\n    max-height: 85px;\n  }\n  \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 20px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 12px;\n    margin-left: 18px;\n    margin-right: 18px;\n  }\n\n  .image1 {\n    margin-top: -5%;\n    width: 70%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -19%;\n    z-index: 9999;\n    width: 90%;\n    height: 85%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 30px;\n  }\n  \n}\n\n@media (min-width:576px) and (max-width:767.98px) {\n\n  .image-class {\n    max-width: 95px;\n    max-height: 95px;\n  }\n  \n  .textprodText {\n    color: #FFFFFF;\n    font-size: 20px\n  }\n\n  .button {\n    margin-top: 35px;\n    padding: 10px;\n    margin-left: 15px;\n    margin-right: 15px;\n  }\n\n  .image1{\n    margin-top: 20px;\n    width: 60%;\n    height: 23%;\n  }\n\n  .image2 {\n    position: absolute;\n    bottom: -19%;\n    z-index: 9999;\n    width: 80%;\n    height: 85%;\n    filter: drop-shadow(0px 13px 5px #0c3468);\n\n  }\n\n  .textprod {\n    padding-top: 30px;\n  }\n\n  .footer-wrapper {\n    height: 25%;\n  }\n\n}\n\n\n /* Desktop */\n@media (min-width:768px) and (max-width:991.98px) {\n\n  .image-class {\n    max-width: 100px;\n    max-height: 100px;\n  }\n\n  .button {\n    /* margin-top: 50px;\n    padding: 20px; */\n    margin-left: 20px;\n    margin-right: 20px;\n  }\n\n\n  .textprod {\n    padding-top: 30px;\n  }\n\n  /* .footer-wrapper {\n    height: 25%;\n  } */\n\n  .dogImgStyle {\n    position: absolute;\n    width: 85%;\n    height: 95%;\n    top: 18%;\n    /* right: 5%; */\n    bottom: 0px;\n    left: 7%;\n    /* filter: drop-shadow(0px 13px 5px #0c3468); */\n    ;\n  }\n\n}\n\n@media (min-width:992px) and (max-width:1199.98px) {\n .image-class {\n    max-width: 100px;\n    max-height: 100px;\n  }\n\n .textprod {\n    padding-top: 15px;\n  }\n\n  /*  .footer-wrapper {\n    height: 25%;\n  } */\n\n  .dogImgStyle {\n    position: absolute;\n    width: 85%;\n    height: 110%;\n    top: 7%;\n    /* right: 5%; */\n    bottom: 0px;\n    left: 7%;\n    /* filter: drop-shadow(0px 13px 5px #0c3468); */\n    ;\n  }\n}\n\n@media (min-width:1200px) and (max-width:1279.98px) {\n  .image-class {\n    max-width: 105px;\n    max-height: 105px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
